import type { CSSProperties } from 'react';
import type { SxProps, Theme } from '@mui/material';

export const academyMaskedIconClassName = 'skill-svg-icon';

export const academyMaskedIconStyles = {
  root: () =>
    ({
      display: 'inline-block',
      width: '1em',
      height: '1em',
      flex: '0 0 auto',
      backgroundColor: 'currentColor',
      mask: 'var(--skill-icon-url) center / contain no-repeat',
      WebkitMask: 'var(--skill-icon-url) center / contain no-repeat',
    }) as SxProps<Theme>,
};

export function getAcademyMaskedIconStyle(src: string): CSSProperties {
  return {
    '--skill-icon-url': `url("${src}")`,
  } as CSSProperties;
}

export function getAcademyMaskedIconProps(src: string) {
  return {
    className: academyMaskedIconClassName,
    sx: academyMaskedIconStyles.root(),
    'aria-hidden': true,
    style: getAcademyMaskedIconStyle(src),
  };
}
